import { trpc } from '@/shared/api/trpc';

// The reference (e.g. PT60154) of the itinerary the reporter is currently on,
// for the create modal's "Reporting from" chip. Label only — nothing about the
// itinerary's contents is fetched. Skipped entirely when the page has no
// itinerary, and a failed/absent lookup simply yields no chip (never an error
// the reporter has to deal with).
export const useResolveItineraryRef = (itineraryId: string | undefined) =>
  trpc.support.resolveItineraryRef.useQuery(
    { itineraryId: itineraryId ?? '' },
    {
      enabled: Boolean(itineraryId),
      // The reference never changes once assigned, so this is effectively
      // immutable for the life of the session.
      staleTime: Number.POSITIVE_INFINITY,
      retry: false,
    }
  );
